<div>
    <iframe [src]="embedLocation" class="w-100" id="embed-iframe" scrolling="no"></iframe>
</div>
